
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shops/[uuid]/request_reservation",
      function () {
        return require("private-next-pages/shops/[uuid]/request_reservation/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shops/[uuid]/request_reservation"])
      });
    }
  